import React, { useContext, useEffect, useState } from 'react';
import { AppSettings } from '../../config/app-settings';
import { useGetUsersQuery } from '../../redux/apis/usersManagement/users/uMUsersApiSlice';
import { toast } from 'react-toastify';
import Loader from '../pages/loader';
import ReusableTable from '../../components/other/ReuseableTable';
import EditCreateCustomerUser from '../../components/users/EditCreateCustomerUser';
import { can } from '../../helpers/auth';

const CustomerUsers = React.memo(() => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })

  const context = useContext(AppSettings)

  const { data, isLoading, error, isFetching } = useGetUsersQuery({
    expand: ['last_updated_by'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    customer_only:true
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'Last Login',
      dataIndex: 'last_login',
      key: 'last_login',
      search: true
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      search: true
    },
    
    {
      title: 'First Name',
      dataIndex: 'first_name',
      key: 'first_name',
      search: true
    },
    {
      title: 'First Name',
      dataIndex: 'first_name',
      key: 'first_name',
      search: true
    },

    {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',
      search: true
    },
    {
      title: 'Social Media ID',
      dataIndex: 'sm_user_id',
      key: 'sm_user_id',
      search: true
    },

    
    {
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (text, record) => (
        <div className=''>
          
            {text ? "Active": "InActive"}
         
        </div>
      )
    },
    

    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          {can('change_Customer_Users') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = (paginationInfo) => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />
      {can('add_Customer_Users') && create ? (
        <EditCreateCustomerUser
          state={'create'}
          open={create}
          setOpen={setCreate}
          record={null}
        />
      ) : null}
      {can('change_Customer_Users') && edit ? (
        <EditCreateCustomerUser
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      ) : null}
      {can('add_Customer_Users') && (
        <button
          className='btn btn-outline-theme ml-auto'
          onClick={() => setCreate(true)}
        >
          Create New User
        </button>
      )}
      <div className='row'>
        <ReusableTable 
          columns={columns} 
          data={data?.data?.results} 
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.count
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
});

export default CustomerUsers;